var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-pagination',{attrs:{"length":_vm.totalPage},on:{"input":_vm.changePageNumber},model:{value:(_vm.pageNumber),callback:function ($$v) {_vm.pageNumber=$$v},expression:"pageNumber"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }